module.exports = __webpack_public_path__ + "1181a35fb3a76b94898b7fa32838833d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CU.svg
// module id = TROa
// module chunks = 0